import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Auth } from 'aws-amplify';
import { useHistory, useLocation } from 'react-router-dom';

import * as ReactBootStrap from 'react-bootstrap';


const Login = () => {
    let history = useHistory();
    const location = useLocation();
    //Client side error message
    const [userError, setuserError] = useState(null);
    const [isLoading, setLoading] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validated, setValidated] = useState(false);
    //The loginForm object will hold a key-value pair for each of our form fields
    const [loginForm, setloginForm] = useState({});
    const [errors, setErrors] = useState({
        email: loginForm.email,
        Password: loginForm.password,
        errors: {
            cognito: null,
            blankfield: false,
            passwordmatch: false,
        },
    });
    // update the state of form
    const setLoginField = (field, value) => {
        setloginForm({
            ...loginForm,
            [field]: value,
        });
    };
    // fix verify issue
    const [sourcePage, setSourcePage] = useState('login');
    //function to fetch the Coach details


    //function for validation
    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        event.preventDefault();
        // get our new errors
        const formErrors = findsFormErrors();
        // Conditional logic:
        if (Object.keys(formErrors).length > 0) {
            // We got errors!
            setErrors(formErrors);
        } else {
            let errorCount = 0;
            setErrors('');
            if (errorCount === 0) {
                const formdata = {
                    email: loginForm.email,
                    password: loginForm.password,
                };
                setEmail('');
                setPassword('');

                try {
                    //Onload Spinner set to true
                    // console.log("I am here")
                    setLoading(true);
                    let user = null;
                    // Check if the user is already logged-in or not ?
                    try {
                        user = await Auth.currentAuthenticatedUser();
                    } catch (error) {
                        // Handle error if needed
                    }
                    // If user didn't logged in
                    if (!user) {
                        user = await Auth.signIn(loginForm.email, loginForm.password);
                        if (user.challengeName == "NEW_PASSWORD_REQUIRED") {
                            history.push({
                                pathname: '/newpasswordrequired',
                            });
                        }
                    }
                    //log("cognito user", user);
                    //Get the role id from Cognito
                    const user_role = user.attributes['custom:roleid'];
                    localStorage.setItem('user_role', user_role);

                    //after successful cognito login call the user signup api to insert the information into the users table
                    // Sign up API with database
                    let useParams = {
                        email: loginForm.email,
                        channel: 'COGNITO',
                        role_id: user.attributes['custom:roleid'],
                    };
                    let result = await fetch(global.APIPath + global.SignupAPI, {
                        method: 'POST',
                        body: JSON.stringify(useParams),
                    });
                    result = await result.json();
                    // console.log(result);
                    if (
                        result.user.status_description &&
                        result.user.status_description === 'SUSPENDED'
                    ) {
                        setuserError(
                            'Your account is currently suspended. Please reachout to strawket support.'
                        );
                        // console.log("Inside suspended");
                        setLoading(false);
                        logOutHandler();
                        return;
                    } else if (
                        result.user.status_description &&
                        result.user.status_description === 'INACTIVE'
                    ) {
                        setuserError(
                            'Your account is inactive. Please reachout to strawket support.'
                        );
                        setLoading(false);
                        logOutHandler();
                        return;
                    } else if (
                        result.user.status_description &&
                        result.user.status_description === 'ACTIVE'
                    ) {
                        if (
                            !result.hasOwnProperty.call('errorCode') ||
                            result.errorCode === 1005
                        ) {
                            // set user_id, user_email in localStorage
                            let user_id = result.user.user_id;
                            // Set academy_user_id in local storage, if the user is an Academy
                            if (user_role == 1 || user_role == '1')
                                localStorage.setItem('academy_user_id', user_id);

                            // Set coach_user_id in local storage, if the user is a Coach
                            if (user_role == 2 || user_role == '2')
                                localStorage.setItem('coach_user_id', user_id);

                            // Set parent_user_id in local storage, if the user is a Parent
                            if (user_role == 3 || user_role == '3')
                                localStorage.setItem('parent_user_id', user_id);

                            localStorage.setItem('user_email', loginForm.email);
                            // Setting the isAuthenticated flag to true on successfull Authentication
                            localStorage.setItem('isAuthenticated', true);


                            //Setting the redirect path. Normal login the user will be redirect to profile page.
                            //If the user comes with another valid path, then it gets redirected to that page
                            //routing based on the roles and profileupdated flag
                            if (!location.state) {
                                switch (user_role) {
                                    case '1': //Academy
                                        switch (
                                        result.user.is_profile_updated //check the profile updated flag
                                        ) {
                                            case true: // if flag is true that is means the profile information already updated hence move to dashboard
                                                history.push({
                                                    pathname: '/program',
                                                    state: { email: loginForm.email },
                                                });
                                                break;
                                            case false: //If flag is false then go to profile page to gather information
                                                history.push({
                                                    pathname: '/academy_profile',
                                                    state: {
                                                        username: loginForm.email,
                                                        name: user.attributes['custom:username'],
                                                    },
                                                });
                                                break;
                                            default:
                                                break;
                                        }
                                        break;
                                    case '2': // Coach
                                        if (result.user.ispwdchgrequired) {
                                            // If ispwdchgrequired flag is true, then we need to redirect the coach to forgot pwd screen
                                            history.push('/changepswd');
                                        } else {
                                            switch (
                                            result.user.is_profile_updated //check the profile updated flag
                                            ) {
                                                case true: // if flag is true that is means the profile information already updated hence move to dashboard
                                                    history.push({
                                                        pathname: '/coachprogramtable', //changed for dev and to be changed to coach_landing
                                                        state: {
                                                            username: loginForm.email,
                                                            name: user.attributes['custom:username'],
                                                        }, //name is here only for dev and will be reomoved later
                                                    });
                                                    break;
                                                case false: //If flag is false then go to profile page to gather information
                                                    history.push({
                                                        pathname: '/coach_profile',
                                                        state: {
                                                            username: loginForm.email,
                                                            name: user.attributes['custom:username'],
                                                        },
                                                    });
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                        break;
                                    case '3': //Parent
                                        // if (result.user.ispwdchgrequired) {
                                        //   // If ispwdchgrequired flag is true, then we need to redirect the parent to pwd screen
                                        //   history.push('/changepswd');
                                        // } else 
                                        {
                                            // Get the parent data and check the number of students
                                            const parentData = ""
                                            // If the number of kids are more than 1, re-direct the parent to choose the student
                                            if (
                                                parentData &&
                                                parentData.student_array &&
                                                parentData.student_array.length >= 1
                                            ) {
                                                history.push({ pathname: '/userprofilescreen' });
                                            }
                                            // If the number of kid is 1 redirect to parent_landing page
                                            // else if (parentData && parentData.student_array && parentData.student_array.length == 1) {
                                            //   localStorage.setItem('academy_id', parentData.student_array[0].academy_id);
                                            //   localStorage.setItem('academy_name', parentData.student_array[0].academy_name);
                                            //   localStorage.setItem('academy_user_id', parentData.student_array[0].academy_user_id);
                                            //   localStorage.setItem('selected_student_id', parentData.student_array[0].student_id);
                                            //   localStorage.setItem('selected_student_name', parentData.student_array[0].first_name + ' ' + parentData.student_array[0].last_name);
                                            //   // re-direct to parent landing page
                                            //   history.push({pathname: '/parent_landing'});

                                            // // If the kids are 0, then return error
                                            // }
                                            else {
                                                return setuserError(
                                                    'Sorry, We are not able to find any student data'
                                                );
                                            }
                                        }
                                        break;
                                    case '4': // Student
                                        //check the profile updated flag
                                        switch (result.user.is_profile_updated) {
                                            case true: // if flag is true that is means the profile information already updated hence move to dashboard
                                                history.push({
                                                    pathname: '/student_landing',
                                                });
                                                break;
                                            case false: //If flag is false then go to profile page to gather information
                                                history.push({
                                                    pathname: '/student_profile',
                                                });
                                                break;
                                            default:
                                                break;
                                        }
                                        break;
                                }
                            } else {
                                history.push({
                                    pathname: location.state.from,
                                });
                            }
                        } else {
                            // console.log(result.errorCode);
                            //Onload Spinner set to false in case of error response
                            setLoading(false);
                            switch (result.errorCode) {
                                case 1002:
                                    setuserError('Please pass valid email id and password.');
                                    break;
                                case 1003:
                                    setuserError(
                                        'Unable to identify user role information. Please contact help desk.'
                                    );
                                    break;
                                case 2000:
                                    setuserError(
                                        'Technical issue in the system. Please try after sometime.'
                                    );
                                    break;
                                default:
                                    setuserError(
                                        'Technical issue in the system. Please try after sometime.'
                                    );
                            }
                        }
                    }

                } catch (error) {
                    //Onload Spinner set to false whenver there is an error
                    setLoading(false);
                    // console.log(error.message);
                    //This condition handles the situation where the user didn't submit the confirmation code after signup.
                    //Under this circumstance, we'll push the user to fill the verification code.
                    switch (error.message) {
                        case 'User is not confirmed.':
                            history.push({
                                pathname: '/verify',
                                state: { detail: loginForm.email, sourcePage: 'login' }, // fix verify issue
                            });
                            break;
                        case 'Incorrect username or password.':
                            // console.log("error");
                            setuserError('Incorrect username or password.');
                            break;
                        default:
                            setuserError(
                                'Technical issue in the system. Please try after sometime.'
                            );
                    }
                }
            }
        }
    };

    const logOutHandler = () => {
        // Clear all the local storage variables
        localStorage.clear();
        sessionStorage.clear();
        Auth.signOut();
    };
    //Using these cases, we're going to create a function that checks for them, then constructs an errors object with error messages
    const findsFormErrors = () => {
        const { email, password } = loginForm;
        const newErrors = {};
        if (!email || email === '') newErrors.email = 'Please enter your email id!';


        // validate password condition
        if (!password || password === '')
            newErrors.password = 'Please enter your password!';
        // else if (!isValidPassword(password))
        //   newErrors.password =
        //     'Password should be min of 8 chars having combination of number, special character, lower & upper case letters';
        return newErrors;
    };

    //function for the password viewer
    function toggleEyebtn() {
        const passwordField = document.getElementById('password');
        if (passwordField.type === 'password') {
            passwordField.type = 'text';
        } else if (passwordField.type === 'text') {
            passwordField.type = 'password';
        }
    }

    //autoredirect from login to role specific landing page if user is already logged in

    return (
        <div className="container-fluid mx-0 px-0">
            <Row className="g-0">
                {
                    <div className="row g-0">
                        {/* Add error message display under navbar */}
                        {userError && (
                            <div className="alert alert-danger" role="alert">
                                {userError}
                            </div>
                        )}
                        {/* <!--row forms the whole page and it is divided into 2 columns
             (left container and right container)
              g-0 will remove the blank space between the rows and columns--> */}
                        <div className="col-md-6">
                            {/* <!--This is the first column where only the image is present--> */}
                            <div className="leftcontainer d-flex justify-content-center align-items-center">
                                {/* <!--leftcontainer has some custom style applied in standard.css
                          d-flex is the flexbox where the items are aligned one after the other (horizontally)--> */}
                                {/* <img src="/img/login.png" className="img-fluid w-60" alt="" /> */}
                                {/* <!--fluid doesn't allow the image to go out of container-->   
               <!--W-50 will reduce the image size by 50%-->*/}
                            </div>
                        </div>

                        <div className="col-md-6 rightcontainer pt-5 pb-3">
                            {/* <!--d-flex created flex box align the div horizontally
                  sm,md and lg - Set the break points based on screen size (small,medium,large)
                  py - padding at y axis (px - x axis)
                  mx - margin at x axis --> */}
                            {/* Onload Spinner display if flag is true imported from Reactbootstrap */}

                            <div>
                                {/* <Row className="mx-3 d-flex justify-content-end">
                      <Col
                        sm={5}
                        md={5}
                        className="AlreadyHaveAnAccount d-flex justify-content-end align-items-center me-4"
                      >
                        Don&apos;t you have an account ?
                      </Col>
                      <Col
                        sm={2}
                        md={2}
                        className="d-flex justify-content-end align-items-center"
                      >
                        <Button
                          onClick={() => {
                            history.push('/signup');
                          }}
                          variant="outline-dark"
                          size="lg"
                        >
                          Sign Up
                        </Button>
                      </Col>
                    </Row> */}
                                <Row className="mx-3 mt-5">
                                    <Col>
                                        <h1>Welcome!</h1>
                                    </Col>
                                </Row>
                                <Row className="RegisterYourAccount mx-3">
                                    <Col>Login to your account</Col>
                                </Row>

                                <Form
                                    noValidate
                                    validated={validated}
                                    onSubmit={handleSubmit}
                                    className="pt-4"
                                >
                                    <Row className="mx-3 mb-3">
                                        <Col sm={12} md={12}>
                                            <Form.Floating>
                                                <Form.Control
                                                    type="email"
                                                    id="emailid"
                                                    className="form.control"
                                                    placeholder="Email id"
                                                    required //required shows up as invalid on page load
                                                    isInvalid={!!errors.email} // Bootstrap will highlight the input box red upon a true value for isInvalid
                                                    onChange={(e) =>
                                                        setLoginField('email', e.target.value)
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {/* we need to display error in our form!*/}
                                                    {errors.email}
                                                </Form.Control.Feedback>
                                                <label htmlFor="emailid" className="form-label">
                                                    Email Id
                                                    <span style={{ color: 'rgba(255,49,49,1)' }}>*</span>
                                                </label>
                                            </Form.Floating>
                                        </Col>
                                    </Row>
                                    <Row className="mx-3 mb-3">
                                        <Col sm={12} md={12}>
                                            <Form.Floating>
                                                <Form.Control
                                                    id="password"
                                                    type="password"
                                                    placeholder="Password"
                                                    className="form-control"
                                                    required //required shows up as invalid on page load
                                                    isInvalid={!!errors.password} // Bootstrap will highlight the input box red upon a true value for isInvalid
                                                    onChange={(e) =>
                                                        setLoginField('password', e.target.value)
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {' '}
                                                    {/* we need to display error in our form!*/}
                                                    {errors.password}
                                                </Form.Control.Feedback>
                                                <label htmlFor="password" className="form-label">
                                                    Password
                                                    <span style={{ color: 'rgba(255,49,49,1)' }}>*</span>
                                                </label>
                                                <i
                                                    className="fa fa-eye"
                                                    aria-hidden="true"
                                                    id="eyebtn"
                                                    onClick={toggleEyebtn}
                                                ></i>
                                            </Form.Floating>
                                        </Col>
                                    </Row>
                                    <Row className="mx-3">
                                        <a
                                            href="#"
                                            className="link-primary small"
                                            onClick={() => {
                                                history.push('/forgotpswd');
                                            }}
                                        >
                                            forgot password
                                        </a>
                                    </Row>
                                    {/* Error and Warning message for the user */}

                                    <Row className="mx-3">
                                        {/* <!--d-flex created flex box align the div horizontally
                     sm,md and lg - Set the break points based on screen size (small,medium,large)
                      py - padding at y axis (px - x axis)
                       mx - margin at x axis --> */}
                                        <Col
                                            sm={12}
                                            md={12}
                                            className="d-flex justify-content-end align-items-center"
                                        >
                                            <Button type="submit" variant="dark" size="lg">
                                                Log In
                                                {/* <i className="fa fa-long-arrow-right"></i> */}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                                {/* commented for future */}
                                {/* <Row className="separator mx-4 py-4">Or With</Row>
                    <Row className="d-flex justify-content-center mx-3">
                      <Col
                        ms={4}
                        md={4}
                        className="d-flex flex-wrap justify-content-center py-4"
                      >
                        <Col
                          id="google"
                          className="d-flex flex-wrap justify-content-center"
                          onClick={() =>
                            Auth.federatedSignIn({ provider: 'Google' })
                          }
                        >
                          <FcGoogle className="icons" />
                        </Col>
                        <Col
                          id="facebook"
                          className="d-flex flex-wrap justify-content-center"
                          onClick={() =>
                            Auth.federatedSignIn({ provider: 'Facebook' })
                          }
                        >
                          <BsFacebook
                            className="icons"
                            style={{ color: 'rgb(103, 103, 224)' }}
                          />
                        </Col>
                        <Col
                          id="apple"
                          className="d-flex flex-wrap justify-content-center"
                          onClick={() =>
                            Auth.federatedSignIn({ provider: 'Apple' })
                          }
                        >
                          <BsApple className="icons" />
                        </Col>
                      </Col>
                    </Row> */}
                            </div>
                        </div>
                    </div>
                }
            </Row>
        </div>
    );
};

export default Login;